module.exports = __webpack_public_path__ + "static/media/basic_user_banner.98ff2ca7.png";